export default "__VITE_ASSET__OVc8pdtJ__"